import { useEffect, useState } from 'react';

import { faInfoCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css, useTheme } from 'styled-components';

import { useAssignmentsFilters } from '../../contexts/assignmentsFilters/useAssignmentsFilters';

const Tooltip = styled.div<{ visible: boolean }>`
  display: block;
  position: absolute;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  top: 38px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 3px;
  box-shadow: ${({ theme }) => theme.colors.shadow.dropdown};
  right: 0;
  z-index: 100;
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 6px;
`;

const FilterSearchInputContainer = styled.div`
  display: flex;
  position: relative;
  align-self: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const InputBorder = styled.label<{ highlight?: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: ${({ theme }) => theme.sizes.radius.input}px;
  padding: 7px 10px;
  cursor: text;
  white-space: nowrap;

  ${({ highlight, theme }) =>
    highlight &&
    css`
      background-color: ${theme.colors.background.highlight};
    `}
`;

const Input = styled.input`
  border: none;
  outline: none;
  font: inherit;
  background: transparent;
  color: inherit;
`;

interface Props {
  className?: string;
}

const FilterSearchInput: React.FC<Props> = ({ className }) => {
  const theme = useTheme();
  const [text, setText] = useState<string>('');
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const {
    state: { searchText },
    setSearchText,
  } = useAssignmentsFilters();

  const toggleShowTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  useEffect(() => setText(searchText), [searchText]);

  useEffect(() => {
    const doSearch = setTimeout(() => {
      setSearchText(text);
    }, 200);

    return () => clearTimeout(doSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return (
    <FilterSearchInputContainer className={className}>
      <InputBorder highlight={!!text}>
        <Input
          onChange={(e) => setText(e.currentTarget.value)}
          placeholder="Sök"
          value={text}
        />
        <FontAwesomeIcon
          color={theme.colors.border.primary}
          icon={faInfoCircle}
          onClick={() => toggleShowTooltip()}
          onMouseLeave={() => setShowTooltip(false)}
          style={{ marginRight: '10px', cursor: 'pointer' }}
        />
        <FontAwesomeIcon icon={faSearch} onClick={() => setSearchText(text)} />
      </InputBorder>
      <Tooltip visible={showTooltip}>
        <strong>Sökbara kolumner:</strong>
        <ul>
          <li>Regnr</li>
          <li>Kund</li>
          <li>Från</li>
          <li>Till</li>
          <li>Län</li>
          <li>Fälttestare</li>
          <li>Bokare</li>
        </ul>
      </Tooltip>
    </FilterSearchInputContainer>
  );
};

export default FilterSearchInput;
